export enum ARTICLE_ROUTES {
  GET_ALL = "/article",
  GET_ALL_CLIENTS = "/clients",
  GET = "/article/",
  CREATE = "/article",
  UPDATE = "/article/",
  REMOVE = "/article/",
}
